module.exports = __webpack_public_path__ + "img/20.da5893a6.jpg";